export const INLINE_SEARCH_PLACEHOLDER_TERMS = [
  'Claude engineering',
  'Agentic AI',
  "Master's in AI",
  'Data analytics',
  'Product manager',
  'AI with Python',
  'MCP',
] as const;

export const INLINE_SEARCH_SURFACE = 'catalog_page' as const;

export const INLINE_SEARCH_ORIGIN = 'catalog_inline_search' as const;
export const HEADER_SEARCH_ORIGIN = 'header_search' as const;
export const URL_SEARCH_ORIGIN = 'url' as const;
